import * as core from '../../../../../../../core'

import { query } from './stakeholders-by-impact-and-influence.query'

export const RESOURCE = {
  payload: {
    alias: 'stakeholders.by.impact.and.influence',
    description:
      'Matrix of stakeholder counts by degree of impact and influence',
    name: 'Stakeholders by Impact and Influence',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
